import { Box, ThemeUIStyleObject } from 'theme-ui';
import React from 'react';
import useUpdateEffect from '~/hooks/components/use-update-effect';

// Passing no properties will play an infinite loading animation without mirroring progress
type Props = {
  startPercent?: number;
  loaded?: boolean;
  absolute?: boolean;
  color?: string;
  forwardSx?: ThemeUIStyleObject;
  loaderWidth?: number;
  setLoaderWidth?: (value: number) => void;
};
const SpinnerBar = ({ startPercent, loaded, absolute, color, forwardSx = {}, loaderWidth, setLoaderWidth }: Props) => {
  const position = absolute ?? false;

  useUpdateEffect(() => {
    if (loaderWidth && setLoaderWidth) {
      setLoaderWidth(startPercent ?? 0);
    }
  }, [startPercent]);

  return (
    <Box
      sx={{
        position: position ? 'absolute' : 'relative',
        top: position && '50%',
        left: position && '50%',
        transform: position && 'translate(-50%,-50%)',
        width: '70px',
        height: '2px',

        backgroundColor: 'rgba(0,0,0,0.2)',
        opacity: loaded ? 0 : 1,
        transition: 'opacity 0.4s ease',
        zIndex: 2,
        ':after': {
          position: 'absolute',
          content: '""',
          top: 0,
          left: 0,
          height: '100%',
          backgroundColor: color ?? 'black',
          width: loaderWidth ? loaderWidth + '%' : '0%',
          animation: !loaderWidth && 'spinner 3s ease infinite',
          transition: loaderWidth && loaderWidth < 100 ? 'width 4s ease' : 'width .5s ease',
        },
        ...forwardSx,
      }}
    />
  );
};

export default React.memo(SpinnerBar);
